// extracted by mini-css-extract-plugin
export default {"loaderBox":"Loader_loaderBox__UQo05","loader":"Loader_loader__cNLdr","spin":"Loader_spin__Tv1UQ"};